
          // client side hydration entrypoint for a particular route generated by fastify-renderer
          import React from 'react'
          import ReactDOM from 'react-dom'
          import { routes } from "/@fstr!route-table.js?base=&lazy=true"
          import { Root } from "/app/node_modules/.pnpm/github.com+gadget-inc+fastify-renderer@5a38f7e6b1bde82ae2e27657410506d72fe9b38f_fastify@4.29._6r7maupj6oq2t2t2y3vj3wc7w4/node_modules/fastify-renderer/client/react/index.js"
          import Layout from "docs/src/RootContainer.tsx"
          import Entrypoint from "/@fs//app/packages/docs/pages/guides/3-multi-env/getting-started/What-is-Gadget.mdx"

          ReactDOM.unstable_createRoot(document.getElementById('fstrapp'), {
            hydrate: true
          }).render(<Root
            Layout={Layout}
            Entrypoint={Entrypoint}
            basePath={""}
            routes={routes}
            bootProps={window.__FSTR_PROPS}
          />)
        